// Core Web Vitals capture (first-party RUM).
//
// The Better Stack browser tag auto-captures LCP/FCP/TTFB into pre-aggregated
// (`*_ns_avg`) columns — averages only, no INP, no CLS. We instead emit every
// vital as a RAW per-navigation sample over a same-origin beacon
// (`/api/web-vitals`), which the server records as an OTLP histogram. That
// lands all five vitals as a queryable metric (`frontend.web_vital`, broken
// down by `metric`) the Frontend Performance dashboard charts at avg/p95 — and,
// unlike the third-party tag, it can't be ad-blocked. Registered from
// `instrumentation-client` (Vercel-only).

import { type Metric, onCLS, onFCP, onINP, onLCP, onTTFB } from 'web-vitals';
import { clientNetworkTag } from './client';
import { beaconVitals } from './vitals-beacon';

/** Beacon one vital sample. `value` is ms for LCP/INP/FCP/TTFB, a unitless
 *  layout-shift score for CLS — disambiguated by the `metric` field. */
function report(metric: Metric): void {
  beaconVitals({
    kind: 'vital',
    metric: metric.name,
    value: metric.value,
    rating: metric.rating,
    network: clientNetworkTag(),
  });
}

/** Register all five Core Web Vitals listeners. Each reports once per page
 *  lifetime (web-vitals default); LCP/INP/CLS settle on page-hide. */
export function initWebVitals(): void {
  onLCP(report);
  onINP(report);
  onCLS(report);
  onFCP(report);
  onTTFB(report);
}
